const DEFAULT_PAGE_NUMBER = 0;
const DEFAULT_PAGE_SIZE = 20;
export const NotificationCenterConst = {
  FETCH_INTERVAL: 60000, // 60 seconds

  DEFAULT_FILTERS: {
    pageNumber: DEFAULT_PAGE_NUMBER,
    pageSize: DEFAULT_PAGE_SIZE,
  },
  
  DEFAULT_FILTERS_COUNT: {
    attributes: [],
  },
};
